var _path, _path2, _path3, _path4, _g, _path5, _g2, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 309,
    viewBox: "0 0 309 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_7232)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_7232",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 309,
    height: 309
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M309 0H0V309H309V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_7232)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.476 247.242C222.847 254.971 262.207 236.185 264.556 190.882C268.08 122.928 208.724 130.269 191.438 112.36C174.151 94.4501 193.516 119.902 160.225 82.789C138.03 58.0468 108.456 57.9198 71.5017 82.4088C41.6943 106.669 38.4705 138.484 61.8294 177.854C85.1882 217.223 113.403 240.353 146.476 247.242Z",
    fill: "#EEF5D8",
    fillOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M248.755 119.637C244.374 119.637 240.827 116.084 240.827 111.705C240.827 107.325 244.374 103.772 248.755 103.772C253.135 103.772 256.682 107.325 256.682 111.705C256.682 116.084 253.135 119.637 248.755 119.637ZM248.755 115.116C250.629 115.116 252.152 113.591 252.152 111.705C252.152 109.819 250.629 108.294 248.755 108.294C246.879 108.294 245.356 109.819 245.356 111.705C245.356 113.591 246.879 115.116 248.755 115.116Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_7232",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 77,
    width: 122,
    height: 35
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M230.239 77.2966H110.048L109.979 111.664H230.168L230.239 77.2966Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_7232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.768 79.0398C127.17 79.0398 129.096 88.1433 129.096 97.2304V107.144C129.096 108.715 130.29 109.992 131.76 109.992L222.511 109.202C223.982 109.202 225.175 107.927 225.175 106.356V95.6681C225.175 85.9187 217.78 78.0137 208.66 78.0137C208.042 78.0137 111.124 79.0398 111.768 79.0398Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.766 80.7062C111.766 82.1925 112.974 83.3986 114.461 83.3986C208.679 83.3986 208.696 83.3977 208.714 83.3986C214.888 83.4092 219.891 88.4553 219.9 94.6843V107.456H222.565C224.035 107.456 225.228 106.253 225.228 104.77V94.6843C225.268 85.4731 217.898 77.9743 208.768 77.9348H208.661H207.666C207.422 77.9493 207.184 77.9887 206.942 78.0147H114.457C112.971 78.0147 111.766 79.2199 111.766 80.7062Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_7232",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 75,
    width: 149,
    height: 162
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M221.019 75.5654H73.1589V236.563H221.019V75.5654Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_7232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.661 83.0669V78.0132H112.7C100.127 78.0324 89.9382 88.3064 89.9189 100.984V232.889C89.9189 234.371 91.1126 235.574 92.5825 235.574H174.745C187.302 235.535 197.465 225.265 197.474 212.603V94.6645V94.5384C197.552 88.3613 202.535 83.0842 208.661 83.0756C208.686 83.0756 208.709 83.0679 208.733 83.0669H208.661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.648 78.0131C100.074 78.0333 89.8844 88.3074 89.8651 100.985V178.208L147.239 77.9419L112.648 78.0131Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9181 132.131V102.687C89.9383 90.0084 100.127 79.7353 112.701 79.7151H208.661M83.0989 231.922C88.8293 231.922 89.8661 225.834 89.8661 221.986C89.8661 190.521 89.9181 168.279 89.9181 160.3M90.4196 141.127V144.665",
    stroke: "#E6E6E6",
    strokeWidth: 7.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.661 77.9333H207.666C198.957 78.4638 192.158 85.7363 192.146 94.5395V94.7907V212.537C192.13 220.56 186.755 227.564 179.06 229.592C178.219 229.81 177.357 229.918 176.497 229.927V229.93H176.43H176.362H76.7523C80.751 233.46 85.9819 235.605 91.7123 235.61H91.748H120.468H174.746C175.331 235.61 176.236 235.61 176.823 235.52C177.858 235.425 178.884 235.252 179.894 235.002C190.209 232.579 197.515 223.311 197.528 212.627V94.629V94.5038C197.604 88.7137 202.003 83.9208 207.718 83.3972C208.034 83.3798 208.639 83.3818 208.952 83.3972L208.661 77.9333Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_0_7232",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 205,
    width: 110,
    height: 32
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.579 205.802H67.3837V236.082H176.579V205.802Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_0_7232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.659 77.9336H207.665C198.955 78.465 192.159 85.7366 192.146 94.5397V94.7909V212.537C192.13 220.561 186.756 227.566 179.061 229.592C177.314 230.047 175.479 230.047 173.733 229.592C166.013 227.537 160.641 220.484 160.662 212.43V208.848C160.673 207.364 159.489 206.151 158.018 206.143H141.135H127.561H106.634H84.7242H71.6288C70.1589 206.143 68.9652 207.347 68.9652 208.83V212.628C68.9537 225.31 79.1401 235.6 91.7128 235.61H91.7465H120.466H174.743C175.33 235.61 176.235 235.61 176.822 235.521C177.857 235.425 178.885 235.253 179.894 235.002C190.21 232.58 197.514 223.312 197.527 212.628V94.6302V94.5041C197.603 88.7149 202.003 83.9201 207.719 83.3984C208.05 83.3801 208.381 83.3801 208.713 83.3984C214.887 83.408 219.89 88.455 219.901 94.6831V107.456H222.564C224.035 107.456 225.229 106.253 225.229 104.769V94.6831C225.267 85.4718 217.897 77.974 208.767 77.9336H208.659Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_0_7232",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 309,
    height: 309
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H309V309H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_0_7232)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_0_7232",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 81,
    width: 108,
    height: 150
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M198.54 81.5818C192.283 81.5818 111.423 81.5818 111.423 81.5818L97.2243 91.6893L91.9299 122.252V206.241C91.9299 206.241 156.425 206.241 158.35 206.241C160.276 206.241 160.516 207.925 160.516 209.129C160.516 210.332 161.72 230.306 175.918 230.306C190.117 230.306 192.042 217.311 192.042 210.091C192.042 202.872 192.042 95.2991 192.042 92.8925C192.042 90.486 194.93 83.2664 198.54 81.5818Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_0_7232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.226 190.742C227.365 177.786 228.345 155.844 215.416 141.733C202.485 127.621 180.542 126.686 166.402 139.642C152.262 152.599 151.28 174.541 164.211 188.653C177.14 202.763 199.086 203.699 213.226 190.742Z",
    fill: "#CAD8E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.226 190.742C227.365 177.786 228.345 155.844 215.416 141.733C202.485 127.621 180.542 126.686 166.402 139.642C152.262 152.599 151.28 174.541 164.211 188.653C177.14 202.763 199.086 203.699 213.226 190.742Z",
    stroke: "#CAD8E9",
    strokeWidth: 7.2,
    strokeMiterlimit: 10
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M111.38 182.713H137.423",
    stroke: "#A9CC3D",
    strokeWidth: 7.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M111.38 158.455H137.423",
    stroke: "#A9CC3D",
    strokeWidth: 7.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M111.379 134.197H170.411",
    stroke: "#A9CC3D",
    strokeWidth: 7.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M111.379 108.206H177.232",
    stroke: "#A9CC3D",
    strokeWidth: 7.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M214.982 180.142C216.797 178.333 219.733 178.336 221.545 180.146L244.444 203.007C246.251 204.811 246.253 207.738 244.449 209.546L244.441 209.554C242.626 211.361 239.691 211.36 237.877 209.55L214.978 186.689C213.172 184.884 213.17 181.957 214.974 180.15L214.982 180.142Z",
    fill: "#A9CC3D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M219.867 184.87C234.007 171.914 234.987 149.972 222.057 135.861C209.127 121.75 187.184 120.814 173.044 133.77C158.904 146.727 157.922 168.67 170.852 182.781C183.782 196.892 205.728 197.827 219.867 184.87Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M219.867 184.87C234.007 171.914 234.987 149.972 222.057 135.861C209.127 121.75 187.184 120.814 173.044 133.77C158.904 146.727 157.922 168.67 170.852 182.781C183.782 196.892 205.728 197.827 219.867 184.87Z",
    stroke: "#A9CC3D",
    strokeWidth: 7.2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M209.262 167.109L205.977 170.392L197.524 161.938L189.133 170.327L185.831 167.026L194.221 158.634L185.766 150.18L189.051 146.896L197.504 155.351L205.895 146.961L209.197 150.264L200.807 158.655L209.262 167.109Z",
    fill: "#A9CC3D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_7232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 309,
    height: 309,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyOrder);
export default __webpack_public_path__ + "static/media/empty_order.e44f64c4c8811a4d90124699b8638f18.svg";
export { ForwardRef as ReactComponent };